import { createStore } from 'vuex'

const store =  createStore({
  state () {
    return {
      loginStatus:false,
      loadingStatus:false,
      progress:-1,
      menuToggled:false,
      breadcrumbView:{
      },
      nowPage:''
    }
  },
  getters: {
  },
  mutations: {
    setBreadcrumb(state,data){
      console.log('setBreadcrumb->',data)
      state.breadcrumbView = data
    },
    setLoadingStatus(state, status) {
      state.loadingStatus = status;
    },
    setProgress(state, value) {
      console.log('setProgress')
      state.progress = value;
    }
  },
  actions: {
  },
  modules: {
  }
})

// 訂閱者邏輯
store.subscribe((mutation, state) => {
  if (mutation.type === 'setLoadingStatus' && state.loginStatus === false) {
    store.commit('setProgress', -1);
  }
});


export default store